import { useQuery } from '@tanstack/react-query';
import { parentTuitionBandApi } from '@/features/reports/api/parentTuitionBand.api';
import { groupComparisonsFilterQueryKeys } from '@/features/reports/hooks/useGroupComparisonsSchoolBandsQuery';

/** GET /api/app/parent-tuition-band?Year=… */
export function useGroupComparisonsParentBandsQuery(year: string | undefined) {
  const y = year?.trim() ?? '';
  const yearNum = Number(y);
  const enabled = y !== '' && Number.isFinite(yearNum);

  return useQuery({
    queryKey: groupComparisonsFilterQueryKeys.parentBands(y),
    queryFn: () =>
      parentTuitionBandApi.getList({
        year: yearNum,
        skipCount: 0,
        maxResultCount: 100,
      }),
    enabled,
    staleTime: 5 * 60 * 1000,
  });
}
